export default "__VITE_ASSET__D5IGZZzA__"